// Sentry 초기화 — main.tsx 최상단에서 import.
// VITE_SENTRY_DSN이 비어있으면 init 자체를 건너뛰어 로컬 개발/테스트 환경에 영향 없도록 한다.
import * as Sentry from '@sentry/react';

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0.1,
  });
  console.info('[Sentry] initialized', { mode: import.meta.env.MODE });
}
